module.exports = __webpack_public_path__ + "img/revel-ptv.d90a806f.png";